import { Store, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import { WishlistsBackInStockItemEntity } from "../entities/WishlistsBackInStockItemEntity";

export type WishlistsBackInStockItemsState = {
    items: WishlistsBackInStockItemEntity[];
};

const createInitialState = (): WishlistsBackInStockItemsState => ({
    items: [],
});

@singleton()
@StoreConfig({ name: "WishlistsBackInStockItemsStore" })
class WishlistsBackInStockItemsStore extends Store<WishlistsBackInStockItemsState> {
    constructor() {
        super(createInitialState());
    }
}

export default WishlistsBackInStockItemsStore;
